// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SafetyCertificateFilledSvg from "@ant-design/icons-svg/es/asn/SafetyCertificateFilled";
import AntdIcon from '../components/AntdIcon';

var SafetyCertificateFilled = function SafetyCertificateFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SafetyCertificateFilledSvg
  }));
};

SafetyCertificateFilled.displayName = 'SafetyCertificateFilled';
export default React.forwardRef(SafetyCertificateFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/SafetyCertificateFilled.js
// module id = 1739
// module chunks = 0